import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PurchasesListQuery } from "../graphql/queries";
import type {
  PurchasesListQueryType,
  PurchasesListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const usePurchasesQuery = (
  options?: QueryHookOptions<
    PurchasesListQueryType,
    PurchasesListQueryVariablesType
  >
) => {
  return useQuery<PurchasesListQueryType, PurchasesListQueryVariablesType>(
    PurchasesListQuery,
    options
  );
};
